import {
    ComponentSelectors,
    ComponentSelector,
    ComponentObject,
    ComponentElements,
    ComponentService,
    ComponentInjector,
    UIComponent
} from '@atypon/ui-utils';

class Texts extends ComponentObject { }

class ClassList extends ComponentObject { }

class Selectors extends ComponentSelectors {
    rangeField = new ComponentSelector('.timeframe__static-range');
    customRange = new ComponentSelector('.timeframe__custom-range-filter');
    customRangeRadio = new ComponentSelector('#customRange');
    radios = new ComponentSelector('.radio--primary input');
    selects = new ComponentSelector('select');
    timeRangeAlert = new ComponentSelector("#time_range_interval_alert");
}

class Elements extends ComponentElements<Selectors> {
    protected _oldRadio: HTMLElement;
    radios: HTMLElement[] = [];
    selects: HTMLElement[] = [];
    timeRangeAlert: HTMLElement;
    customRangeRadio: HTMLInputElement;

    get oldRadio(): HTMLElement {
        return this._oldRadio;
    }

    set oldRadio(value: HTMLElement) {
        this._oldRadio = value;
        this.disabledAllFields();
        const parent = value.closest(`${this.selectors.rangeField.selector}, ${this.selectors.customRange.selector}`);
        this.enableSiblingFields(parent);
    }

    /**
    * all selects are already store so basically loop through them and disable them all.
    *
    */
    disabledAllFields() {
        this.selects.forEach(item => {
            item.setAttribute('disabled', 'true');
        });
    }

    /**
    *  loop through Sibling selects and enable them all
    *
    * @param {HTMLElement} parent - the radio button shared parent
    */
    enableSiblingFields(parent) {
        if (!parent) {
            return;
        }
        this.domUtils.getElements(this.selectors.selects.selector, parent).forEach(item => {
            item.removeAttribute('disabled');
        });
    }
}

interface AdvancedSearchRangeFields extends ComponentService<Selectors, Elements, ClassList, Texts> { }

@ComponentInjector(Selectors, Elements, ClassList, Texts)
class AdvancedSearchRangeFields implements UIComponent {

    constructor(readonly wrapper: HTMLElement, readonly onChanged: (Event) => void) { }

    initialize(): void {
        if (!this.wrapper) {
            return;
        }
        this.elements.initialize(this.wrapper);
        this.addEventListeners();
    }

    addEventListeners() {
        this.elements.radios.forEach(radio => {
            this.domUtils.addEventListener(radio, 'click', this.onChange.bind(this, radio));
        });
        this.elements.selects.forEach(select => {
            this.domUtils.addEventListener(select, 'change', this.onChanged);
        });
    }

    /**
     * click event listener, disables all fields then enables sibling fields
     *
     */
    protected onChange(radio: HTMLElement, event: Event) {
        if (radio === this.elements.oldRadio) {
            return;
        }
        this.elements.oldRadio = radio;
        this.onChanged(event)
    }

    public shouldDisable() {
        const values = {
            fromYear: 0,
            fromMonth: 0,
            toYear: 0,
            toMonth: 0,
        }
        this.elements.selects.forEach((item: HTMLSelectElement) => {
            //since the id is the same name as the key of the values
            if (values.hasOwnProperty(item.id)) {
                values[item.id] = parseInt(item.value)
            }
        })
        const { fromYear, fromMonth, toYear, toMonth } = values;
        // Check if "customRange" is selected and if end date is before start date or NaN values
        const customRangeSelected = this.elements.customRangeRadio?.checked ?? false;
        const hasNaNValues = Object.values(values).some(v => isNaN(v));
        const endDateBeforeStartDate = (toYear < fromYear) || (toYear === fromYear && toMonth < fromMonth);
        const isDisabled: boolean = customRangeSelected && (hasNaNValues || endDateBeforeStartDate);
        const alertText = this.elements.timeRangeAlert?.getAttribute('data-label');
        const isNaNCombinedDate = toYear + fromYear + toMonth + fromMonth;

        if (this.elements.timeRangeAlert) {
            if (isDisabled && !isNaN(isNaNCombinedDate)) {
                this.elements.timeRangeAlert.style.display = 'block';
                this.elements.timeRangeAlert.innerHTML = alertText;
            }
            else {
                this.elements.timeRangeAlert.style.display = 'none';
                this.elements.timeRangeAlert.innerHTML = '';
            }
        }

        return customRangeSelected && (hasNaNValues || endDateBeforeStartDate);
    }
}

export default AdvancedSearchRangeFields;

export {
    Elements as AdvancedSearchRangeFieldsElements,
    Selectors as AdvancedSearchRangeFieldsSelectors,
    ClassList as AdvancedSearchRangeFieldsClassList,
    Texts as AdvancedSearchRangeFieldsTexts
}
